<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="分类名称：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
            <el-form-item label="是否显示：" prop="is_show">
                <el-select clearable v-model="model.is_show" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { checkName } from '@/api/goodscate'

export default {
    name: 'goodsCateEdit',
    mixins: [editutil],
    props: {
        pid: {
            type: Number,
            default() {
                return 0;
            }
        },
    },
    data() {
        return {
            model: {
                name: '',
                ccode: '',
                pid: '',
                order_index: '',
                is_show: '1',
            },
            getObj:{
                url:'/api/admin/goodscate/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
            rules: {
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'},
                    {validator: this.checkCateName, trigger: 'blur' }
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
                is_show: [
                    {required: true, message: '是否显示不能为空', trigger: 'blur'},
                ]
            },
            exits_p_name: 'name',
            exits_p_title: '名称',
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.model.pid = this.pid
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/goodscate/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.is_show = this.model.is_show+""
        },
        checkCateName(ule, value, callback){
            if (value.trim() != '') {
                let check = true;
                if (this.id > 0) {
                    if (this.model['name'].trim() === this.old_check.trim()) {
                        check = false;
                    }
                }
                if (check) {
                    let pid1 = this.pid
                    checkName(value.trim(), pid1).then(res => {
                        if (res.code === 1) {
                            callback();
                        } else {
                            callback(new Error(res.msg));
                        }
                    }).catch();
                } else {
                    callback();
                }
            }
        }
    }
};
</script>